module.exports = __webpack_public_path__ + "img/icon89.68ae94a4.png";